export default __webpack_public_path__ + "static/media/GalanoGrotesque.2111c73e.ttf";